export default __webpack_public_path__ + "static/mini-map-f6554731330131588c9f5dffffb8234b.png";